import type { ExtractThemeOverrides, Theme } from '../../_mixins'
import type { ThemeCommonVars } from '../../_styles/common'
import { commonLight } from '../../_styles/common'
import commonVariables from './_common'

export function self(vars: ThemeCommonVars) {
  const {
    heightSmall,
    heightMedium,
    heightLarge,
    textColor1,
    errorColor,
    warningColor,
    lineHeight,
    textColor3
  } = vars
  return {
    ...commonVariables,
    blankHeightSmall: heightSmall,
    blankHeightMedium: heightMedium,
    blankHeightLarge: heightLarge,
    lineHeight,
    labelTextColor: textColor1,
    asteriskColor: errorColor,
    feedbackTextColorError: errorColor,
    feedbackTextColorWarning: warningColor,
    feedbackTextColor: textColor3
  }
}

export interface FormThemeVars extends ReturnType<typeof self> {}

const formLight: FormTheme = {
  name: 'Form',
  common: commonLight,
  self
}

export interface FormTheme extends Theme<'Form', FormThemeVars> {}

export interface FormThemeOverrides extends ExtractThemeOverrides<FormTheme> {}

export default formLight
